module.exports = __webpack_public_path__ + "img/steamwhite.67a34ff9.svg";